import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';

class ServerErrorModal extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        const props = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Возникла ошибка</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-default"
                            onClick={props.onHide}>
                        Закрыть
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ServerErrorModal;


// WEBPACK FOOTER //
// ./src/modals/ServerErrorModal.js